// all the charts for chapter 1
require('./charts/chapter-1/chart-0/chart');
require('./charts/chapter-1/chart-1/chart');
require('./charts/chapter-1/chart-2a/chart');
require('./charts/chapter-1/chart-2b/chart');
require('./charts/chapter-1/chart-2c/chart');
require('./charts/chapter-1/chart-3a/chart');
require('./charts/chapter-1/chart-3b/chart');
require('./charts/chapter-1/chart-3c/chart');
require('./charts/chapter-1/chart-4a/chart');
require('./charts/chapter-1/chart-4b/chart');
require('./charts/chapter-1/chart-4c/chart');
require('./charts/chapter-1/chart-4d/chart');
require('./charts/chapter-1/chart-4e/chart');
require('./charts/chapter-1/chart-4f/chart');
require('./charts/chapter-1/chart-4g/chart');
require('./charts/chapter-1/chart-4h/chart');
require('./charts/chapter-1/chart-4i/chart');
require('./charts/chapter-1/chart-4j/chart');
require('./charts/chapter-1/chart-4k/chart');
require('./charts/chapter-1/chart-5a/chart');
require('./charts/chapter-1/chart-5b/chart');
require('./charts/chapter-1/chart-5c/chart');
require('./charts/chapter-1/chart-5d/chart');
require('./charts/chapter-1/chart-5e/chart');
require('./charts/chapter-1/chart-6a/chart');
require('./charts/chapter-1/chart-6b/chart');
require('./charts/chapter-1/chart-6c/chart');
require('./charts/chapter-1/chart-6d/chart');
require('./charts/chapter-1/chart-6e/chart');
require('./charts/chapter-1/chart-8/chart');
require('./charts/chapter-1/chart-9/chart');
require('./charts/chapter-1/chart-10/chart');
require('./charts/chapter-1/chart-11/chart');
require('./charts/chapter-1/chart-12/map');
require('./charts/chapter-1/chart-12/chart');
require('./charts/chapter-1/chart-14/map');
require('./charts/chapter-1/chart-14/chart');
require('./charts/chapter-1/chart-15a/chart');
require('./charts/chapter-1/chart-15b/chart');
require('./charts/chapter-1/chart-15c/chart');
require('./charts/chapter-1/chart-15d/chart');
require('./charts/chapter-1/chart-15e/chart');
require('./charts/chapter-1/chart-15f/chart');
// require('./charts/chapter-1/chart-16/chart');
require('./charts/chapter-1/chart-16b/chart');
